<mat-form-field *ngFor="let slot of slots(); let i = index"
                appearance="outline"
                class="xp-otp-input__field"
                [class.xp-otp-input__field--error]="invalid()">
	<input matInput
	       class="xp-otp-input__box"
	       type="password"
	       maxlength="1"
	       autocomplete="one-time-code"
	       inputmode="numeric"
	       [value]="characters()[i]"
	       [disabled]="disabled()"
	       (input)="onInput(i)"
	       (keyup)="onKeyup($event, i)"
	       #box />
</mat-form-field>
